export const formatDragVariable = (
    nodeName: string,
    variable: string,
    type: "input" | "output"
): string => {
    return type === "output"
        ? variable
            ? `{{${nodeName}.outputs.${variable}}}`
            : `{{${nodeName}.outputs}}`
        : variable
            ? `{{${nodeName}.inputs.${variable}}}`
            : `{{${nodeName}.inputs}}`;
};
